const numberToLocaleString = (number = 0) => {
  return number.toLocaleString('en-US', { style: 'decimal' });
};

export default numberToLocaleString;
